import React, { PureComponent } from 'react';
import './BackToTop.scss';

class BackToTop extends PureComponent {
  constructor(props) {
    super(props);
    this.gotoTop = this.gotoTop.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // if (window.pageYOffset >= (this.props.isImageExist ? 200 : 100)) {
    //     document.body.classList.add('scrolltop');
    // } else {
    //     document.body.classList.remove('scrolltop');
    // }
  };

  gotoTop = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="backtop" onClick={() => this.gotoTop()}>
        <span className="backtop_icon fa fa-chevron-up"></span>
      </div>
    );
  }
}

export default BackToTop;
